import { z } from 'zod';
import LangEnum from '../../../../lang/LangEnum';
import { StatusType } from '../../../orders/order.types';
import { RachelToolName } from '../../rachel.types';
import { ToolApprovalAction } from './toolApprovalLabel.types';

const TOOL_APPROVAL_LABEL: Partial<Record<RachelToolName, LangEnum>> = {
  [RachelToolName.CREATE_ORDER]: LangEnum.RACHEL_APPROVAL_ACTION_CREATE_ORDER,
  [RachelToolName.UPDATE_ORDER]: LangEnum.RACHEL_APPROVAL_ACTION_UPDATE_ORDER,
  [RachelToolName.EDIT_ORDER_ITEMS]: LangEnum.RACHEL_APPROVAL_ACTION_EDIT_ITEMS,
  [RachelToolName.REMOVE_ORDER_ITEMS]: LangEnum.RACHEL_APPROVAL_ACTION_REMOVE_ITEMS,
  [RachelToolName.UPDATE_ORDER_CONDITION]: LangEnum.RACHEL_APPROVAL_ACTION_UPDATE_CONDITION,
  [RachelToolName.CHANGE_ORDER_STATUS]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS,
  [RachelToolName.EXECUTE_CODE]: LangEnum.RACHEL_APPROVAL_ACTION_EXECUTE_CODE,
};

const CHANGE_ORDER_STATUS_LABEL: Partial<Record<StatusType, LangEnum>> = {
  [StatusType.DRAFT]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS_DRAFT,
  [StatusType.IN_REVISION]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS_IN_REVISION,
  [StatusType.ON_APPROVAL]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS_ON_APPROVAL,
  [StatusType.APPROVED]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS_APPROVED,
  [StatusType.SENT]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS_SENT,
  [StatusType.CANCELED]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS_CANCELED,
  [StatusType.ABANDONED]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS_ABANDONED,
  [StatusType.REJECTED]: LangEnum.RACHEL_APPROVAL_ACTION_CHANGE_STATUS_REJECTED,
};

const ChangeOrderStatusInputSchema = z.object({
  codigoPedido: z.string().min(1),
  novoStatus: z.enum(StatusType),
});

const isRachelToolName = (toolName: string): toolName is RachelToolName =>
  Object.values<string>(RachelToolName).includes(toolName);

const getChangeOrderStatusAction = (input: unknown): ToolApprovalAction | undefined => {
  const parsed = ChangeOrderStatusInputSchema.safeParse(input);
  if (!parsed.success) {
    return undefined;
  }

  const labelKey = CHANGE_ORDER_STATUS_LABEL[parsed.data.novoStatus];
  return labelKey ? { labelKey, values: { code: parsed.data.codigoPedido } } : undefined;
};

export const getToolApprovalAction = (toolName: string, input: unknown): ToolApprovalAction => {
  if (!isRachelToolName(toolName)) {
    return { labelKey: LangEnum.RACHEL_APPROVAL_ACTION_GENERIC };
  }

  const detailedAction =
    toolName === RachelToolName.CHANGE_ORDER_STATUS ? getChangeOrderStatusAction(input) : undefined;

  return (
    detailedAction ?? {
      labelKey: TOOL_APPROVAL_LABEL[toolName] ?? LangEnum.RACHEL_APPROVAL_ACTION_GENERIC,
    }
  );
};
